import { object, string } from 'yup'

export const signInDtoSchema = object({
    email: string().email().required(),
    password: string().required(),
})
